export const adjustText = (value, maxLen) => {
  const v = value ?? '';
  const a = [...v];
  const len = a.length;
  if (len > maxLen) {
    return a.join('');
  }
  return value;
};
